export const common = {
  // Navigation
  'nav.features': 'Fitur',
  'nav.howItWorks': 'Cara kerja',
  'nav.pricing': 'Harga',
  'nav.faq': 'FAQ',
  'nav.aboutUs': 'Tentang kami',
  'nav.getStarted': 'Mulai',

  // Hero Section
  'hero.badge': 'AI keputusan untuk ceruk bisnis',
  'hero.title1': 'Ide itu murah.',
  'hero.title2': 'Keputusan buruk tidak.',
  'hero.subtitle': 'AI yang mengevaluasi ceruk bisnis Anda',
  'hero.subtitleLine2': 'sebelum Anda berinvestasi.',
  'hero.cta': 'Periksa ide',
  'hero.ctaSecondary': 'Cara kerja',
  'hero.stat1Value': '30',
  'hero.stat1Label': 'Kredit per permintaan',
  'hero.stat2Value': 'Dari 7',
  'hero.stat2Label': 'Tingkat penilaian',
  'hero.stat3Value': '100%',
  'hero.stat3Label': 'Jujur dan pribadi',

  // Features Section
  'features.title1': 'Fitur canggih untuk',
  'features.title2': 'bisnis',
  'features.title3': 'modern',
  'features.honestVerdict.title': 'Penilaian jujur, bukan skor hype',
  'features.honestVerdict.description': 'Vonis bagus/sedang/lemah yang jelas, didukung data pasar nyata dan riset kompetitor. Tidak ada skor 9/10 yang dirancang untuk menyanjung setiap ide.',
  'features.fullJourney.title': 'Dari uji ide ke Builder Report',
  'features.fullJourney.description': 'Validasi di obrolan, dalami analisis pasar, ekspor Builder Report 25–75 halaman dengan persona, keuangan, go-to-market, dan pitch deck.',
  'features.multilingual.title': '21 bahasa, data pasar lokal',
  'features.multilingual.description': 'Dari UKM Swiss hingga solo founder di São Paulo — AI menjawab dalam bahasamu, dengan sumber dari pasarmu.',

  // How It Works
  'howItWorks.title': 'Cara kerja',
  'howItWorks.subtitle': 'Empat langkah menuju kejelasan tentang niche bisnis Anda.',
  'howItWorks.step1Title': 'Pilih paket',
  'howItWorks.step1Desc': 'Starter, Pro atau Builder - tergantung kedalaman tinjauan Anda.',
  'howItWorks.step2Title': 'Tanya AI',
  'howItWorks.step2Desc': 'Ajukan pertanyaan Anda tentang niche. Setiap permintaan memerlukan 30 kredit.',
  'howItWorks.step3Title': 'Dapatkan penilaian jujur',
  'howItWorks.step3Desc': 'AI menilai: Bagus, Sedang atau Buruk. Tanpa basa-basi.',
  'howItWorks.step4Title': 'Buat keputusan',
  'howItWorks.step4Desc': 'Sekarang Anda tahu apakah layak untuk melanjutkan.',

  // Pricing
  'pricing.title': 'Harga',
  'pricing.subtitle': 'Pilih paket yang sesuai dengan kedalaman tinjauan Anda.',
  'pricing.yearlyDiscount': 'Langganan tahunan:',
  'pricing.yearlyDiscountValue': 'Diskon -20%',
  'pricing.perMonth': 'per bulan',
  'pricing.selectPlan': 'Pilih paket',
  'pricing.mostPopular': 'Paling populer',
  'pricing.footer': 'Semua harga dalam CHF. Kredit hanya dipotong untuk respons AI yang berhasil.',
  
  // Starter Plan
  'pricing.starter.name': 'Starter',
  'pricing.starter.description': 'Untuk tes realitas awal.',
  'pricing.starter.credits': '2.500 kredit',
  'pricing.starter.feature1': 'Hasilkan ide niche',
  'pricing.starter.feature2': 'Perbaiki niche',
  'pricing.starter.feature3': 'Pemeriksaan realitas pasar',
  'pricing.starter.feature4': 'Penilaian kompetisi',
  'pricing.starter.feature5': 'Penilaian waktu',
  'pricing.starter.feature6': 'Penilaian jujur',
  'pricing.starter.feature7': 'Sesi pribadi',
  'pricing.starter.feature8': 'Riwayat dan ekspor',

  // Pro Plan
  'pricing.pro.name': 'Pro',
  'pricing.pro.description': 'Untuk tinjauan lebih mendalam.',
  'pricing.pro.credits': '5.000 kredit',
  'pricing.pro.feature1': 'Semua fitur Starter',
  'pricing.pro.feature2': 'Lebih banyak kredit untuk tinjauan intensif',
  'pricing.pro.feature3': 'Saran perbaikan',
  'pricing.pro.feature4': 'Niche alternatif',
  'pricing.pro.feature5': 'Analisis pasar terperinci',
  'pricing.pro.feature6': 'Dukungan prioritas',
  'pricing.pro.feature7': 'Filter lanjutan',
  'pricing.pro.feature8': 'Favorit sesi',

  // Builder Plan
  'pricing.builder.name': 'Builder',
  'pricing.builder.description': 'Ide → Briefing pengembang.',
  'pricing.builder.credits': 'Kredit tak terbatas',
  'pricing.builder.feature1': 'Semua fitur Pro',
  'pricing.builder.feature2': 'Permintaan AI tak terbatas',
  'pricing.builder.feature3': 'Mode Builder: Briefing pengembang',
  'pricing.builder.feature4': 'Ikhtisar proyek terstruktur',
  'pricing.builder.feature5': 'Alur pengguna dan fungsi inti',
  'pricing.builder.feature6': 'Catatan teknis',
  'pricing.builder.feature7': 'Tentukan non-tujuan',
  'pricing.builder.feature8': 'Batas tarif penggunaan wajar',
  'pricing.builder.limitNote': 'Batas penggunaan wajar',
  'pricing.monthlyReset': 'Reset bulanan',

  // Modal
  'pricing.modal.selected': 'dipilih',
  'pricing.modal.comingSoon': 'Pendaftaran dan pemrosesan pembayaran akan segera tersedia.',
  'pricing.modal.patience': 'Kami bekerja untuk memberi Anda pengalaman yang aman dan lancar. Harap bersabar.',
  'pricing.modal.understood': 'Mengerti',

  // FAQ
  'faq.title': 'FAQ',
  'faq.subtitle': 'Dijawab dengan jujur dan kritis.',
  'faq.q1': 'Apa yang dilakukan IdeaOracle.ai secara konkret?',
  'faq.a1': 'IdeaOracle.ai mengevaluasi ide bisnis dan niche untuk logika pasar, permintaan nyata, persaingan, diferensiasi, dan kelayakan.\nJika ada substansi, kami menunjukkan bagaimana bisa dipertajam secara strategis.\nJika tidak, kami mengatakannya.',
  'faq.q2': 'Apakah kalian juga menghasilkan ide?',
  'faq.a2': 'Ya.\nTapi tidak secara buta.\nKami mengembangkan pendekatan berdasarkan logika pasar – bukan motivasi atau hype tren.',
  'faq.q3': 'Apakah kalian mengoptimalkan model bisnis?',
  'faq.a3': 'Ya – jika ada potensi.\nKami tidak memoles ilusi.\nKami membuat konsep yang layak menjadi lebih tangguh.',
  'faq.q4': 'Apa yang membedakan kalian dari alat AI lain?',
  'faq.a4': 'Alat lain memberikan inspirasi.\nKami memberikan penilaian.\nFokusnya pada realisme, bukan antusiasme.',
  'faq.q5': 'Apakah ini jaminan kesuksesan?',
  'faq.a5': 'Tidak.\nKami mengurangi keputusan buruk – kami tidak menghilangkan risiko.',
  'faq.q6': 'Untuk siapa IdeaOracle.ai?',
  'faq.a6': 'Pendiri sebelum peluncuran\nPengusaha sebelum ekspansi\nSide-builder sebelum investasi waktu\nInvestor sebelum evaluasi\n\nSingkatnya: Untuk orang yang menginginkan kejelasan sebelum modal.',
  'faq.q7': 'Bagaimana jika saya hanya mencari validasi?',
  'faq.a7': 'Maka IdeaOracle.ai bukan alat yang tepat.',
  'faq.q8': 'Seberapa jujur analisisnya?',
  'faq.a8': 'Sejujur yang diizinkan data dan mekanika pasar.\nTanpa euforia. Tanpa belas kasihan.',
  'faq.q9': 'Apakah kalian menggantikan riset pasar?',
  'faq.a9': 'Tidak.\nKami adalah pra-penilaian strategis – bukan studi pasar lengkap.',
  'faq.q10': 'Mengapa begitu tanpa kompromi?',
  'faq.a10': 'Karena kegagalan itu mahal.\nKejujuran tidak.',

  // Footer
  'footer.description': 'Platform ini tidak membantu Anda merasa baik - tetapi membuat keputusan yang tepat.',
  'footer.product': 'Produk',
  'footer.aiAssistant': 'Asisten AI',
  'footer.howItWorks': 'Cara kerja',
  'footer.pricing': 'Harga',
  'footer.faq': 'FAQ',
  'footer.legal': 'Hukum',
  'footer.privacy': 'Privasi',
  'footer.terms': 'Ketentuan',
  'footer.imprint': 'Imprint',
  'footer.support': 'Dukungan',
  'footer.contact': 'Kontak',
  'footer.documentation': 'Dokumentasi',
  'footer.copyright': '© 2025 IdeaOracle.ai. Hak cipta dilindungi.',

  // AI Assistant
  'aiAssistant.title': 'Asisten AI niche',
  'aiAssistant.subtitle': 'Pertanyaan tentang niche',
  'aiAssistant.welcomeMessage': 'Hai! Jelaskan ide Anda atau tanyakan tentang niche. Saya akan memberi Anda penilaian yang jelas dan jujur.',
  'aiAssistant.demoResponse': 'Ini adalah demo. Untuk mendapatkan penilaian AI yang sebenarnya, silakan daftar dan pilih paket.',
  'aiAssistant.placeholder': 'Jelaskan ide Anda...',

  // Header & Sidebar
  'dashboard.header.title': 'Dasbor',
  'dashboard.sidebar.overview': 'Ikhtisar',
  'dashboard.sidebar.newAnalysis': 'Asisten AI',
  'dashboard.sidebar.history': 'Riwayat',
  'dashboard.sidebar.credits': 'Kredit',
  'dashboard.sidebar.settings': 'Pengaturan',

  // Dashboard Overview
  'dashboard.overview.welcome': 'Selamat datang kembali, {{name}}',
  'dashboard.overview.subtitle': 'Berikut ikhtisar cepat aktivitas Anda',

  // Dashboard Stats
  'dashboard.stats.creditsRemaining': 'Kredit tersisa',
  'dashboard.stats.totalAnalyses': 'Total analisis',
  'dashboard.stats.goodRatings': 'Penilaian positif',
  'dashboard.stats.nextReset': 'Reset berikutnya dalam',
  'dashboard.stats.days': 'hari',

  // Quick Actions
  'dashboard.quickActions.title': 'Tindakan cepat',
  'dashboard.quickActions.checkNewIdea': 'Periksa ide',
  'dashboard.quickActions.checkNewIdeaDesc': 'Analisis ide bisnis yang ada',
  'dashboard.quickActions.generateIdea': 'Hasilkan ide',
  'dashboard.quickActions.generateIdeaDesc': 'Temukan niche menguntungkan baru',
  'dashboard.quickActions.builderBriefing': 'Briefing Builder',
  'dashboard.quickActions.builderBriefingDesc': 'Ubah ide menjadi briefing siap pengembang',
  'dashboard.quickActions.premiumOnly': 'Hanya Builder',

  // Chat Header
  'chat.title': 'Asisten AI niche',
  'chat.subtitle': 'Ajukan pertanyaan tentang niche. Saya menilai secara kritis dan jujur.',
  'chat.creditsLabel': 'Kredit',

  // Chat Welcome
  'chat.welcomeTitle': 'Selamat datang di Asisten AI niche',
  'chat.welcomeDesc': 'Jelaskan ide Anda atau tanyakan tentang niche. Saya akan menilai dengan jujur: Bagus, Sedang atau Buruk.',
  'chat.aiWelcome': 'Hai! Jelaskan ide Anda atau tanyakan tentang niche. Saya akan memberi Anda penilaian yang jelas dan jujur.',

  // Chat Suggestions
  'chat.suggestion1': 'Temukan niche menguntungkan untuk saya.',
  'chat.suggestion2': 'Saya punya ide - nilai dengan jujur.',
  'chat.suggestion3': 'Niche mana yang memiliki potensi sekarang?',
  'chat.suggestion4': 'Perbaiki niche ini dan buat lebih spesifik.',

  // Chat Actions
  'chat.newConversation': 'Percakapan baru',
  'chat.today': 'Hari ini',
  'chat.yesterday': 'Kemarin',
  'chat.thisWeek': 'Minggu ini',
  'chat.thisMonth': 'Bulan ini',
  'chat.older': 'Lebih lama',
  'chat.messages': 'pesan',
  'chat.renameConversation': 'Ganti nama',
  'chat.deleteConversation': 'Hapus',
  'chat.cancel': 'Batal',
  'chat.rename': 'Ganti nama',
  'chat.delete': 'Hapus',
  'chat.favorite': 'Tambah favorit',
  'chat.unfavorite': 'Hapus favorit',
  'chat.searchSessions': 'Cari percakapan...',
  'chat.noResults': 'Tidak ada hasil ditemukan',
  'chat.noSessions': 'Belum ada percakapan',
  'chat.enterNewName': 'Masukkan nama baru...',
  'chat.deleteConfirmMessage': 'Apakah Anda yakin ingin menghapus percakapan ini? Tindakan ini tidak dapat dibatalkan.',

  // Chat Input & Errors
  'chat.inputPlaceholder': 'Ketik pertanyaan Anda… (memerlukan 30 kredit)',
  'chat.send': 'Kirim',
  'chat.voice': 'Bicara',
  'chat.listeningPlaceholder': 'Saya mendengarkan... Bicara sekarang.',
  'chat.stopListening': 'Hentikan rekaman',
  'chat.recording': 'Merekam...',
  'chat.speechNotSupported': 'Pengenalan suara tidak didukung oleh browser Anda.',
  'chat.microphonePermissionDenied': 'Akses mikrofon ditolak. Harap izinkan akses di pengaturan browser Anda.',
  'chat.errorNotEnoughCredits': 'Kredit tidak cukup. Harap tingkatkan paket Anda atau tunggu reset berikutnya.',
  'chat.errorAiFailed': 'Respons AI gagal. Tidak ada kredit yang dipotong.',
  'chat.errorRateLimit': 'Terlalu banyak permintaan. Harap tunggu sebentar.',

  // Ratings
  'rating.good': 'Bagus',
  'rating.medium': 'Sedang',
  'rating.bad': 'Buruk',

  // Auth Page
  'auth.branding.headline1': 'Tidak setiap ide itu bagus.',
  'auth.branding.headline2': 'Kami memberi tahu Anda dengan jujur.',
  'auth.branding.subtitle': 'AI keputusan untuk niche bisnis. Jelas. Kritis. Tanpa basa-basi.',
  'auth.benefits.privacy.title': '100% Pribadi',
  'auth.benefits.privacy.desc': 'Ide Anda tetap sepenuhnya pribadi dan aman.',
  'auth.benefits.honest.title': 'AI Jujur',
  'auth.benefits.honest.desc': 'Tanpa basa-basi – hanya umpan balik yang jelas dan kritis.',
  'auth.benefits.fast.title': 'Hasil Cepat',
  'auth.benefits.fast.desc': 'Dapatkan kejelasan tentang niche Anda dalam hitungan menit.',
  'auth.trust.users': 'Pengguna Aktif',
  'auth.trust.ideas': 'Ide Dianalisis',
  'auth.trust.rating': 'Penilaian',
  'auth.login.title': 'Masuk',
  'auth.login.headline': 'Selamat datang kembali',
  'auth.login.subtitle': 'Masuk untuk melanjutkan perjalanan Anda.',
  'auth.login.forgotPassword': 'Lupa kata sandi?',
  'auth.login.submit': 'Masuk',
  'auth.login.noAccount': 'Belum punya akun?',
  'auth.login.signUp': 'Daftar',
  'auth.register.title': 'Daftar',
  'auth.register.headline': 'Buat akun Anda',
  'auth.register.subtitle': 'Mulai analisis ide bisnis Anda hari ini.',
  'auth.register.submit': 'Buat Akun',
  'auth.register.hasAccount': 'Sudah punya akun?',
  'auth.register.signIn': 'Masuk',
  'auth.fields.name': 'Nama Lengkap',
  'auth.fields.email': 'Alamat Email',
  'auth.fields.password': 'Kata Sandi',
  'auth.fields.confirmPassword': 'Konfirmasi Kata Sandi',
  'auth.fields.selectPlan': 'Pilih paket Anda',
  'auth.placeholders.name': 'Masukkan nama Anda',
  'auth.placeholders.email': 'Masukkan email Anda',
  'auth.placeholders.password': 'Masukkan kata sandi Anda',
  'auth.placeholders.confirmPassword': 'Konfirmasi kata sandi Anda',
  'auth.terms.accept': 'Saya menerima',
  'auth.terms.terms': 'Syarat dan Ketentuan',
  'auth.privacy.accept': 'Saya menerima',
  'auth.privacy.policy': 'Kebijakan Privasi',
  'auth.errors.nameRequired': 'Nama wajib diisi',
  'auth.errors.emailRequired': 'Email wajib diisi',
  'auth.errors.emailInvalid': 'Masukkan email yang valid',
  'auth.errors.passwordRequired': 'Kata sandi wajib diisi',
  'auth.errors.passwordLength': 'Kata sandi harus minimal 8 karakter',
  'auth.errors.passwordMismatch': 'Kata sandi tidak cocok',
  'auth.loading': 'Mohon tunggu...',
  'auth.or': 'atau lanjutkan dengan',
  'auth.social.google': 'Lanjutkan dengan Google',
  'auth.social.apple': 'Lanjutkan dengan Apple',

  // Trial Plan
  'pricing.trial.name': 'Trial',
  'pricing.trial.description': 'Akses gratis 3 hari',
  'pricing.trial.credits': '250 kredit',
  'pricing.trial.free': 'Gratis',
  'pricing.trial.duration': 'Tanpa biaya selama 3 hari',
  'pricing.trial.cta': 'Mulai uji coba gratis',
  'pricing.trial.feature1': '250 kredit untuk menjelajahi AI',
  'pricing.trial.feature2': 'Akses penuh selama 3 hari',
  'pricing.trial.feature3': 'Tanpa kartu kredit',
  'pricing.trial.feature4': 'Batalkan kapan saja',

  // Gold Package
  'pricing.gold.name': 'Gold',
  'pricing.gold.description': '10.000 kredit + laporan Builder 25 halaman',
  'pricing.gold.credits': '10.000 kredit',
  'pricing.gold.feature1': '10.000 kredit',
  'pricing.gold.feature2': 'Laporan Builder 25 halaman',
  'pricing.gold.feature3': 'Semua fitur Starter & Pro',
  'pricing.gold.feature4': 'Analisis pasar & ringkasan',
  'pricing.gold.feature5': 'Peluang, risiko, rekomendasi',
  'pricing.gold.feature6': 'Unduh PDF',
  'pricing.gold.feature7': 'Dukungan',

  // Platinum Package
  'pricing.platinum.name': 'Platinum',
  'pricing.platinum.description': '15.000 kredit + laporan Builder 100 halaman',
  'pricing.platinum.credits': '15.000 kredit',
  'pricing.platinum.feature1': '15.000 kredit',
  'pricing.platinum.feature2': 'Laporan Builder 100 halaman',
  'pricing.platinum.feature3': 'Semua fitur Gold',
  'pricing.platinum.feature4': 'Mode Builder: briefing pengembang',
  'pricing.platinum.feature5': 'Ringkasan terstruktur',
  'pricing.platinum.feature6': 'Analisis pasar lanjutan',
  'pricing.platinum.feature7': 'Dukungan',

  // Pricing UI
  'pricing.monthly': 'Bulanan',
  'pricing.yearly': 'Tahunan',
  'pricing.savings': 'hemat',
  'pricing.billedYearly': 'Ditagih tahunan',

  // Hero trial CTA
  'hero.trialTitle': 'Mulai uji coba gratis Anda',
  'hero.creditsLabel': 'Kredit',
  'hero.trialTagline': 'Coba asisten AI kami gratis selama 3 hari',
  'hero.trialCta': 'Daftar & dapatkan 250 kredit',
  'hero.trialNoCard': 'Tanpa kartu kredit. Tanpa komitmen.',

  // Admin
  'admin.dashboard.tabs.plans': 'Paket',

  // Credit top-up
  'dashboard.credits.topup.button': 'Isi ulang kredit',
  'dashboard.credits.topup.buttonTitle': 'Beli kredit tambahan tanpa mengubah paket',
  'dashboard.credits.topup.title': 'Isi ulang kredit',
  'dashboard.credits.topup.subtitle': 'CHF 0,15 per kredit — tanpa perubahan paket',
  'dashboard.credits.topup.quickAmounts': 'Pilihan cepat',
  'dashboard.credits.topup.custom': 'Kustom',
  'dashboard.credits.topup.totalLabel': 'Total',
  'dashboard.credits.topup.creditsLabel': 'Kredit',
  'dashboard.credits.topup.confirm': 'Beli sekarang',
  'footer.disclaimer': 'Penafian',
  'legal.backToHome': 'Kembali ke beranda',
  'legal.lastUpdated': 'Terakhir diperbarui',
  'legal.allRightsReserved': 'Hak cipta dilindungi.',
  'legal.authoritativeNotice': 'Versi yang dilokalkan dalam bahasa Anda belum tersedia. Teks bahasa Inggris yang mengikat ditampilkan di bawah.',
  'legal.translationNotice': 'Ini adalah terjemahan untuk kenyamanan. Versi bahasa Inggris adalah dokumen asli yang mengikat secara hukum.',
};

export default common;
